<div class="wm-stateview" [ngClass]="{'hide-canvas': weHaveNoImage}" (window:resize)="onResized()">
  @if (state !== undefined) {
    <wm-canvas #canvas (mouseMoveEvent)="onMouseMove($event.x, $event.y)"></wm-canvas>
  }
  @if (!noActions) {
    <div class="wm-stateview-actions">
      @if (haveValidStatedata()) {
        <div class="wm-stateview-action-showstateviewer" (click)="openStateViewerTool()">
          <fa-icon icon="search" attr.data-testing-id="stateview-{{stateId}}-showstatedata-btn" pTooltip="Show StateData" tooltipPosition="bottom" aria-hidden="true"></fa-icon>
        </div>
      }
    </div>
  }
  @if (!state) {
    <div class="wm-spinner-centered">
      <p-progressSpinner></p-progressSpinner>
      <div class="wm-spinnerlabel">Loading...</div>
    </div>
  }
  @if (weHaveNoImage) {
    <div class="wm-stateview-noscreenshot">
      <div class="wm-statesummary-error-icon">
        <fa-icon [icon]="faQuestionCircle"></fa-icon>
      </div>
      <span>Screenshot unavailable</span>
    </div>
  }
</div>

